import { useQuery } from '@tanstack/react-query';
import { fetchEquipment } from '@services/productOfferingService';
import type { ProductOfferingDTO } from '@t/api.types';

export const useEquipment = <T = ProductOfferingDTO[]>(
  sessionId: string,
  homeId: string,
  planId: string,
  select?: (data: ProductOfferingDTO[]) => T
) => {
  const query = useQuery<ProductOfferingDTO[], Error, T>({
    queryKey: ['equipment', sessionId, homeId, planId],
    queryFn: () => fetchEquipment(sessionId, homeId, planId),
    select,
    enabled: !!sessionId && !!homeId && !!planId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  return {
    equipment: query.data ?? ([] as unknown as T),
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
